// https://css-tricks.com/how-the-vue-composition-api-replaces-vue-mixins/
// https://morioh.com/p/c64947bb64ad

import { reactive, toRefs, watch } from '@vue/composition-api'
import ClientFlowApi, { Handler, ErrorTypes, mapErrorToDisplayError } from '@/api/clientFlow'
import { ErrorDisplay } from '@/components/types/ErrorDisplay'
import { vxm } from '@/state/index'
// import { wait } from '@/lib/utils/wait'

interface State {
  awaitingResponse: boolean;
  hasResponseError: boolean;
  errorDisplay: ErrorDisplay | undefined;
}

const initialState: State = {
  awaitingResponse: false,
  hasResponseError: false,
  errorDisplay: undefined,
}

export default function () {
  // const Api = ClientFlowApi

  const state = reactive({ ...initialState })

  const reset = () => {
    state.errorDisplay = undefined
    state.hasResponseError = false
    state.awaitingResponse = false
  }

  // set hasResponseError = true, when we get an error
  // note-2-self, I could have implemented error handler here! doh!
  watch(() => state.errorDisplay, (error: unknown) => {
    state.hasResponseError = (error !== undefined)
  })

  const before = () => async () => {
    state.errorDisplay = undefined
    state.awaitingResponse = true
    // await wait(5000)
  }

  const onError = (e: ErrorTypes) => () => {
    state.errorDisplay = mapErrorToDisplayError(e, vxm.app.currentLang)
  }

  const after = () => async () => {
    state.awaitingResponse = false
  }

  // Set up the handler with the functions we have defined above
  const handler = new Handler({
    before, after, onError,
  })

  return {
    ClientFlowApi, ...toRefs(state), handler, reset,
  }
}
